const dollarStrFormat = /\B(?=(\d{3})+(?!\d))/g;

export function centsToDollarString(centsAmount: number) {
    let centsAmountStr = centsAmount.toString();
    if (centsAmountStr.length === 0 || Number.isNaN(centsAmount)) {
        return "";
    }
    let prefix = "";
    if (centsAmount < 0) {
        centsAmountStr = centsAmountStr.slice(1);
        prefix = "-";
    }
    const dollarStr = centsAmountStr.length > 2 ? centsAmountStr.slice(0, -2) : "0";
    const formattedDollarStr = dollarStr.replace(dollarStrFormat, ",");
    const centsStr =
        centsAmountStr.length > 2 ? centsAmountStr.slice(-2) : centsAmountStr.padStart(2, "0");
    const cents = Number(centsStr);
    const finalCentsStr = !isNaN(cents) && cents === 0 ? "" : `.${centsStr}`;
    return `${prefix}$${formattedDollarStr}${finalCentsStr}`;
}
